export default function Keys() {
    return function (object) {
        if (!object) {
            return;
        }
        return Object.keys(object);
    };
}
